import { useState } from "react";
import ExtraInfoButton from "./ExtraInfoButton";
import ExtraInfoModal from "./ExtraInfoModal";
import styles from "./ItineraryButton.module.scss";

type ItineraryButtonProps = {
  content: string | null | undefined;
};

export default function ItineraryButton({ content }: ItineraryButtonProps) {
  const [open, setOpen] = useState(false);
  const items = parseContent(content);

  if (items.length === 0) return <></>;

  return (
    <>
      <ExtraInfoButton label="Itinerary" onClick={() => setOpen(true)} />
      <ExtraInfoModal
        open={open}
        title="Itinerary"
        content={
          <div className={styles.timeline}>
            {items.map((item, index) => (
              <div className={styles.timelineItem} key={`${item}-${index}`}>
                <span className={styles.timelineMarker} />
                <p className={styles.timelineText}>{item}</p>
              </div>
            ))}
          </div>
        }
        onClose={() => setOpen(false)}
      />
    </>
  );
}

function parseContent(content: string | null | undefined) {
  return (content ?? "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}
